import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2, X } from "lucide-react";

const MESSAGES = [
  "Restauracja z Krakowa kupiła ten pakiet 15 minut temu",
  "Bar z Trójmiasta właśnie zabezpieczył swój lokal",
  "Kawiarnia z Katowic kupiła Pakiet Bezpieczna Restauracja",
];

const randomInterval = () => 45000 + Math.random() * 45000;

export const SocialProofToast = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const order = [...MESSAGES].sort(() => Math.random() - 0.5);
    let i = 0;
    let showT;
    let hideT;
    let cancelled = false;

    const schedule = (delay) => {
      showT = setTimeout(() => {
        if (cancelled) return;
        setMessage(order[i % order.length]);
        i += 1;
        hideT = setTimeout(() => {
          if (cancelled) return;
          setMessage(null);
          schedule(randomInterval());
        }, 4000 + Math.random() * 1000);
      }, delay);
    };

    schedule(12000);
    return () => {
      cancelled = true;
      clearTimeout(showT);
      clearTimeout(hideT);
    };
  }, []);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          key={message}
          data-testid="social-proof-toast"
          className="fixed bottom-24 left-4 z-[70] max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6 sm:max-w-xs"
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.98 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="relative flex items-start gap-3 rounded-2xl border border-sand bg-white p-4 pr-10 shadow-xl shadow-choc/10">
            <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brick/10">
              <CheckCircle2 className="h-5 w-5 text-brick" />
            </span>
            <div>
              <p className="text-sm font-medium leading-snug text-choc">{message}</p>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-clay">
                Zweryfikowany zakup
              </p>
            </div>
            <button
              data-testid="social-proof-toast-close"
              onClick={() => setMessage(null)}
              aria-label="Zamknij powiadomienie"
              className="absolute right-2.5 top-2.5 rounded-full p-1 text-clay/70 transition-colors duration-300 hover:bg-cream hover:text-choc"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
